
export class ReviewConflictResolutionApiDto {
    public tag: string;
    public codeAuthor: string;
    public isPassed: boolean | null;
}
